import {
  OPEN_MODAL,
  CLOSE_MODAL,
  CLOSE_ORDER_TRACKER_POPUP,
  OPEN_ORDER_TRACKER_POPUP,
} from '../actions';

interface ModalState {
  isOpened: boolean;
  modalType: string;
  data: Record<string, unknown>;
  isVisibleOTPopUp: boolean;
}

interface Action {
  type: string;
  payload?: Record<string, unknown>;
}

const initialState: ModalState = {
  isOpened: false,
  modalType: '',
  data: {},
  isVisibleOTPopUp: false,
};

export const modal = (state: ModalState = initialState, { type, payload }: Action): ModalState => {
  switch (type) {
    case OPEN_MODAL:
      return {
        isOpened: true,
        ...payload,
      } as ModalState;

    case CLOSE_MODAL:
      return {
        isOpened: false,
        modalType: '',
        data: {},
        isVisibleOTPopUp: false,
      };

    case CLOSE_ORDER_TRACKER_POPUP:
      return {
        ...state,
        isVisibleOTPopUp: false,
      };

    case OPEN_ORDER_TRACKER_POPUP:
      return {
        ...state,
        isVisibleOTPopUp: true,
      };

    default:
      return state;
  }
};
